module.exports = __webpack_public_path__ + "img/banner2025.d5f8f171.png";